import { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

import { checkAndRoun } from '../../../../../helpers/topicsHelpers';
import { roundTo } from '../../../../../helpers/helpers';
import { UK_PRIVATE_COMPANY_INSIGHTS_PATH } from '../../../../../data/ukPrivateCompanyInsights';

import EquityItem from '../EquityItem';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const EquityFundraisersMobile = (props) => {
  const {
    currentData, activeType, activeTime, showPeriodChange,
    isCommingSoon, hasInsightsAccess,
  } = props;
  const [isExpand, setIsExpand] = useState(false);

  const headerLength = showPeriodChange ? 1 : 4;

  return (
    <div className={cx('fundraisers-mob', { soon: isCommingSoon || !hasInsightsAccess })}>
      <div className={Styles['fundraisers-mob-header']}>
        <div className={Styles['fundraisers-mob-row']}>
          {currentData.slice(0, headerLength).map((currentItem, i) => (
            <>
              <div className={cx('fundraisers-mob-cell')}>
                {currentItem.currentMonth}
                <br />
                {currentItem.currentYear}
              </div>
              {showPeriodChange && (
                <>
                  <div className={cx('fundraisers-mob-cell', 'changes')}>
                    {activeTime === 'monthly' ? 'MoM' : 'QoQ'}
                    <br />
                    Change
                  </div>
                  <div className={cx('fundraisers-mob-cell', 'changes')}>
                    YoY
                    <br />
                    Change
                  </div>
                </>
              )}
            </>
          ))}
        </div>
      </div>
      <div className={Styles['fundraisers-mob-body']}>
        <div className={Styles['fundraisers-mob-row']}>
          {currentData.slice(0, headerLength).map((currentItem, i) => (
            <>
              <div className={cx('fundraisers-mob-cell')}>
                <Link
                  to={`${UK_PRIVATE_COMPANY_INSIGHTS_PATH}/top-equity-fundraisers/date/${currentItem.currentMonthNumber}-${currentItem.currentYear}`}
                >
                  {activeType === 'count' ? currentItem.transactionCount : checkAndRoun(currentItem.fundsRaised || 0, 2, true, true, true)}
                </Link>
              </div>
              {showPeriodChange && (
                <>
                  <div className={cx('fundraisers-mob-cell')}>
                    {activeType === 'count' ? roundTo(currentItem.momChangesCount || 0, 2) : roundTo(currentItem.momChanges || 0, 2)}
                    %
                  </div>
                  <div className={cx('fundraisers-mob-cell')}>
                    {activeType === 'count' ? roundTo(currentItem.yoyChangesCount || 0, 2) : roundTo(currentItem.yoyChanges || 0, 2)}
                    %
                  </div>
                </>
              )}
            </>
          ))}
          <div
            className={cx('fundraisers-mob-cell', 'expandIcon')}
            onClick={() => setIsExpand(!isExpand)}
          >
            <FontAwesomeIcon icon={isExpand ? faChevronUp : faChevronDown} />
          </div>
        </div>
        {isExpand && (
          <div className={cx('fundraisers-mob-extra')}>
            {currentData.slice(headerLength).map((obj, i) => (
              <EquityItem
                key={i}
                activeType={activeType}
                activeTime={activeTime}
                showPeriodChange={showPeriodChange}
                currentItem={obj}
                isYtd={i === (currentData.length - 1 - headerLength)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EquityFundraisersMobile;
